const list = {
  path: 'messageList',
  component: resolve => require(['@/pages/admin/platform/message/messageList'], resolve)
}

export default list
